import styled from "styled-components";
import TitleSection from "./TitleSection";
import React from "react";
import Swot from "../../swot/Swot";

const SwotSection = ({toggleHandler}) => {
    return (
        <Container>
            <h3 className="swot-title"><span style={{color: "#4BB472FF"}}>S</span><span
                style={{color: "#3394F6"}}>W</span><span style={{color: "#FFB400FF"}}>O</span><span
                style={{color: "#E9405BFF"}}>T</span></h3>
            <Swot entity={'project'} inGuidedUpdate={true}/>
        </Container>
    )
}

const Container = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0.2rem;
    .swot-title{
        font-size: 20px;
        text-align: center;
        font-weight: bolder;
        margin: auto;
        max-width: 30%;
        text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
        -webkit-print-color-adjust: exact;
        -webkit-filter: opacity(1);
    }
`
const Description = styled.p`
    align-self: center;
    font-size: 12px;
    width: 80%;
    text-align: center;
`


export default SwotSection